import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_3 = { class: "invalid-feedback" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_6 = { class: "invalid-feedback" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { src: "data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Me")
], -1)
const _hoisted_11 = {
  src: "https://thispersondoesnotexist.com/image",
  class: "media-left image is-96x96"
}
const _hoisted_12 = { style: {"text-align":"left"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass({ 'has-background-black': _ctx.isDark })
    }, [
      _createElementVNode("strong", {
        class: _normalizeClass({ 'has-text-white': _ctx.isDark })
      }, " Login Form ", 2),
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("label", {
            for: "username",
            class: _normalizeClass({ 'has-text-white': _ctx.isDark })
          }, "Username", 2),
          _hoisted_2,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            autocomplete: "username",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
            name: "username",
            class: _normalizeClass(["form-control", { 'is-invalid': _ctx.submitted && !_ctx.username }])
          }, null, 2), [
            [_vModelText, _ctx.username]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_3, "Username is required", 512), [
            [_vShow, _ctx.submitted && !_ctx.username]
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", {
            htmlFor: "password",
            class: _normalizeClass({ 'has-text-white': _ctx.isDark })
          }, "Password", 2),
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            type: "password",
            autocomplete: "new-password",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
            name: "password",
            class: _normalizeClass(["form-control", { 'is-invalid': _ctx.submitted && !_ctx.password }])
          }, null, 2), [
            [_vModelText, _ctx.password]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_6, "Password is required", 512), [
            [_vShow, _ctx.submitted && !_ctx.password]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: _normalizeClass(["button is-light", { 'is-primary': _ctx.isDark, 'is-info': !_ctx.isDark }]),
            disabled: _ctx.loggingIn
          }, " Login ", 10, _hoisted_8),
          _withDirectives(_createElementVNode("img", _hoisted_9, null, 512), [
            [_vShow, _ctx.loggingIn]
          ])
        ])
      ], 32)
    ], 2),
    _hoisted_10,
    _withDirectives(_createElementVNode("img", _hoisted_11, null, 512), [
      [_vShow, _ctx.me]
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("pre", _hoisted_12, _toDisplayString(_ctx.me), 1)
    ])
  ], 64))
}